module.exports = __webpack_public_path__ + "static/media/click-app-manager.93ea8e35.gif";